import { HOST } from "../constants/HostConstants";

export const promotionApprove = async (promotion_id) => {
  try {
    const response = await fetch(`${HOST}/api/promotion/approve`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        promotion_id,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || "Failed to approve profile promotion");
    }

    return await response.json();
  } catch (error) {
    console.error("Error approving profile promotion:", error);
    throw error;
  }
};
